<template>
  <div class="newPatient-container">
    <div class="container">
      <el-card class="main-container">
        <div class="main-header">
          <div class="main-header-left">
            <span>{{$t('myP')}}</span>
          </div>
          <div class="main-header-right" :class="{'de22':isDe||isFr,'cz22':isCz}">
            <img src="../../assets/back.png">
            <p  @click="back">{{$t('home')}}</p>
          </div>
        </div>
        <hr class="small-hr">
        <div class="item-wrap">
          <div class="item post"><span>{{$t('Postcode')}}</span><input class="name" v-model="profile.zipcode"></div>
          <div class="item"><span>{{$t('Mobile')}}</span><input class="name" v-model="profile.mobile" ></div>
          <div class="item"><span >{{$t('Telephone')}}</span><input class="name" v-model="profile.telephone" ></div>
          <div class="item"><span >{{$t('Email')}}</span><input class="name" v-model="profile.email" ></div>
          <div class="item email"><span >{{$t('Bio')}}</span><input class="name" v-model="profile.motto" ></div>
        </div>



      </el-card>
      <div class="Hcp-footer">
       <span>
<!--         <a href="http://www.medtrum.com/index.php/abouts">{{ $t('contact us') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
                       <a :href="contactURL">{{ $t('contact us') }} </a>
              <a :href="privacyURL">|  {{ $t('Privacy Policy') }} </a>
              <a :href="termsOfUseURL">|  {{ $t('Terms of Use') }} | </a>
          {{$t('copyright')}} <br/>
          <a v-show="isZh" target=_blank href="http://beian.miit.gov.cn/"> 沪ICP备08013753号-3  </a>
          <img v-show="isZh" src="/static/beian.png" />
          <a v-show="isZh" target=_blank href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"> 沪公网安备 31011502014155号 </a>
       </span>
      </div>
    </div>
  </div>
</template>

<script>
  import auth from '../../auth/auth'
  import format from '@/lib/format'
  export default{
    data(){
      return{
        realname:'',gender:'',height:'',weight:'',  isP:true,isD:false,isM:false,isEs:false,isDe:false,isCz:false,
        birthday:'',value2:'',value3:'',isEn:false,isIt:false,isPo:false,isFr:false,isDu:false,isZh:false,isSw:false,
        birthdayShow:'',disDateShow:'',
        dis_type:'11',
        diabetes_type:'',diabetes_diagnosis_date:'',

        address1:'', address2:'', postcode:'', mobile:'', telephone:'', email:'',

        profile:'',  imageUrl: '',uid:0,newPortrait:'',usterType:'',
        pickerOptions:{
          disabledDate(time){
            return time.getTime()>Date.now();
          }
        },
        isEU:true,
        contactURL:'',
        privacyURL:'',
        termsOfUseURL:'',
      }
    },
    computed:{
      portrait(){
        if(this.imageUrl){
          return this.imageUrl;
        }else{
          return '/api/v2.0/person/'+parseInt(sessionStorage.getItem('uid'))+'/portrait'
        }
      }
    },
    methods:{
      checkInput(info){
       if(this.profile.email){
         let re =  /@/;
         if(re.test(this.profile.email)){
           auth.modifyPersonProfile(this,info);
         }else{
           alert('Email Error!');
         }
       }else{
         auth.modifyPersonProfile(this,info);
       }
      },
      back(){
        if(this.usterType==='D'){
          this.$router.push('/PatientList');
        }else if(this.usterType==='M'){
          this.$router.push('/carerConnection');
        }else{
          this.$router.push('/monitor');
        }
      },

      create1(){
        let bthday = '';
        if(typeof this.profile.birthday!== 'string'&&this.profile.birthday!==undefined){
           bthday =format.formatterDate3(this.profile.birthday.getTime()/1000);
        }else{
          bthday =this.profile.birthday;
        }

        let diagonosis_date = '';
        if(typeof this.profile.diabetes_diagonosis_date!== 'string'&&this.profile.diabetes_diagonosis_date!==undefined){
          diagonosis_date =format.formatterDate3(this.profile.diabetes_diagonosis_date.getTime()/1000);
        }else{
          diagonosis_date =this.profile.diabetes_diagonosis_date;
        }

        const obj1 =document.getElementById('dis_type');
        let dis_type = obj1.value;
        const obj2 =document.getElementById('gender');
        let gender = obj2.value;

        let info = {
          realname:this.profile.realname,
          gender:gender,
          height:this.height||this.profile.height,
          weight:this.weight||this.profile.weight,
          birthday:bthday,
          diabetes_type:dis_type,
          diabetes_diagonosis_date:diagonosis_date,
          address:this.profile.address+this.address2,
          zipcode:this.profile.zipcode,
          mobile:this.profile.mobile,
          telephone:this.profile.telephone,
          email:this.profile.email,
          motto:this.profile.motto,
        };
        if(this.newPortrait.length>1){
          info.portrait = this.newPortrait;
        }
        this.checkInput(info);
      },
      create2(){
        let bthday = '';
        if(typeof this.profile.birthday!== 'string'&& this.profile.birthday!==undefined){
          bthday =format.formatterDate3(this.profile.birthday.getTime()/1000);
        }else{
          bthday =this.profile.birthday;
        }
        const obj2 =document.getElementById('gender');
        let gender = obj2.value;
        const obj3 =document.getElementById('major');
        let major = obj3.value;

        let info = {
          realname:this.profile.realname,
          gender:gender,
          birthday: bthday,
          serve_for:this.profile.serve_for,
          major:major,
          address:this.profile.address+this.address2,
          zipcode:this.profile.zipcode,
          mobile:this.profile.mobile,
          telephone:this.profile.telephone,
          email:this.profile.email,
          motto:this.profile.motto,
        };
        if(this.newPortrait.length>1){
          info.portrait = this.newPortrait;
        }
        this.checkInput(info);
      },
      create3(){
        let bthday = '';
        if(typeof this.profile.birthday!== 'string'&& this.profile.birthday!==undefined){
          bthday =format.formatterDate3(this.profile.birthday.getTime()/1000);
        }else{
          bthday =this.profile.birthday;
        }
        const obj2 =document.getElementById('gender');
        let gender = obj2.value;
        let info = {
          realname:this.profile.realname,
          gender:gender,
          birthday:bthday,
          address:this.profile.address+this.address2,
          zipcode:this.profile.zipcode,
          mobile:this.profile.mobile,
          telephone:this.profile.telephone,
          email:this.profile.email,
          motto:this.profile.motto,
        };
        if(this.newPortrait.length>1){
          info.portrait = this.newPortrait;
        }
        this.checkInput(info);
      },

      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.newPortrait = res.path;
        //console.log(res,res.path);
      },
      beforeAvatarUpload(file) {
        const isJPG = (file.type === 'image/jpeg'||file.type === 'image/jpg'||file.type === 'image/png');
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      }
    },
    mounted(){
      this.uid = parseInt(sessionStorage.getItem('uid'));
      this.usterType = sessionStorage.getItem('userType');
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isEs = (lang==='es')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isPo = (lang==='po')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isDu = (lang==='du')?true:false;
      this.isZh= (lang==='zh')?true:false;
      this.isSw= (lang==='sw')?true:false;
      this.isCz= (lang==='cz')?true:false;
      if(this.usterType==='P'){this.isP =true;this.isD =false;this.isM =false;}
      if(this.usterType==='D'){this.isD =true;this.isP =false;this.isM =false;}
      if(this.usterType==='M'){this.isM =true;this.isD =false;this.isP =false;}
      let countryIndex=localStorage.getItem('index');
      //console.info('countryIndex:'+countryIndex);
      if (1==countryIndex || 6==countryIndex || 14==countryIndex) {
        this.isEU=false;
      }
      auth.getProfile(this);
      setTimeout(()=>{
        let host=auth.getOuterHost();
        this.contactURL = host+'/contact.html';
        this.privacyURL = host+'/privacy_policy.html';
        this.termsOfUseURL = host + '/terms_of_use.html';
      }, 50)
    },
  }
</script>
<style scoped>
  .newPatient-container{
    min-height:889px;
    width:100%;
    background-color:#fff;
  }
  .container{
    width:62%;
    margin:0 auto;
    background:#fafbfc;
    padding-top: 15px;
  }
  @media screen and (max-width: 1500px){
    .container{
      width:92%;
    }
  }
  @media screen and (min-height: 950px){
    .container{
      min-height:900px;
    }
  }
  .main-container{
    width:97%;
    min-height: 839px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    position: relative;
  }
  .main-header{
    width: 98%;
    margin:0 auto;
    height:20px;
    margin-bottom: 15px;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }
  .main-header-right{
    float: right;
    width:70px;
    height:20px;
    line-height: 20px;
    margin-right: 1%;
  }
  .de22{
    width:90px;
  }
  .cz22{
    width:80px;
  }
  .main-header-right img{
    display: block;
    margin-top: 5px;
    float: left;
  }
  .main-header-right p{
    float:right;
    color:#0082d2;
    margin-top: 2px;
    cursor: pointer;
  }
  .small-hr{
    background:#e6e8ea;
    width:98%;
    height:1px;
    margin:0 auto 15px;
    border:none;
  }

  .item-wrap{
    width:96%;
    margin:0 auto;
  }
  .item{
    width:95%;
    height:37px;
    line-height: 37px;
    margin-bottom: 15px;
  }
  .item span{
    width:120px;
    height: 100%;
    float: left;
    display: inline-block;
  }
  .ID{
    color:#0082d2;
    margin-left: 50px;
  }
  .portrait{
    margin-bottom: 15px;
  }
  .portrait .porSpan{
    width: 150px;
  }
  .portrait img{
    background:#c9c9c9;
    border-radius:100px;
    width:51px;
    height:50px;
    margin-left: 15px;
    margin-top: -10px;
  }
  .item .name{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:298px;
    height:35px;
    font-size:16px;
    margin-left: 40px;
    padding-left:8px;
    color:#282828;
    font-family:SFUIText-Regular;
  }
  .item select{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:159px;
    height:35px;
    font-size:16px;
    margin-left: 40px;
    color:#282828;
    padding-left: 6px;
    font-family:SFUIText-Regular;
  }
  .item option{
    color: #282828;
    font-family:SFUIText-Regular;
  }
  .item .height{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:151px;
    height:34px;
    font-size:16px;
    margin-left: 40px;
    color:#282828;
    padding-left: 6px;
    font-family:SFUIText-Regular;
  }
  .item .spe-span{
    height:20px;
    line-height: 20px;
    width:120px;
    display: block;
    float: left;
    margin-right: 0px;
  }
  .item .addSpan{
    height:60px;
  }
  .item .address{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:60%;
    height:35px;
    margin-left: 40px;
    margin-bottom: 12px;
    padding-left: 8px;
    color:#282828;
    font-size: 16px;
    font-family:SFUIText-Regular;
  }
  .post{
    clear: both;
    margin-top: 65px;
  }
  .email{
    margin-bottom: 30px;
  }
  .item .unit{
    float:none;
    margin-left: 4px;
    font-size: 18px;
  }

  .item .block{
    margin-left: 40px;
    float: left;
  }
  .item .profession{
    margin-left: 53px;
    width: 185px;
  }
  .item .de1{
    margin-left: 93px;
  }
  .item .org{
    margin-left: 36px;
  }
  .item .zh1{
    margin-left: 99px;
  }
  .item .zh2{
    margin-left: 63px;
  }
  .item .zh3{
    width: 63px;
    margin-right: 36px;
  }
  .el-date-editor.el-input{
    width:159px;
  }
  .item .es1{
    margin-left: 62px;
  }
  .item .es2{
    margin-left: 33px;
  }
  .item .es5{
    width:120px;
    height: 20px;
    line-height: 20px;
    float: left;
    display: inline-block;
    margin:0;
  }
  .item .it1{
    margin-left: 44px;
  }
  .item .it2{
    margin-left: 16px;
  }
  .item .po1{
    margin-left: 62px;
  }
  .item .fr1{
    margin-left: 85px;
  }
  .item .sw1{
    margin-left:100px;
  }
  .item .cz1{
    margin-left:70px;
  }
  .item .cz2{
    margin-left:47px;
  }
  .operate{
    width: 70%;
    float: right;
    margin-top:50px;
    position: absolute;
    bottom: 20px;
    right: 25px;
  }
  .opeP{
    position: inherit;
    margin:50px 25px 20px 0;
  }
  .operate button{
    background: transparent;
    border:1px solid #a3a3a3;
    border-radius:100px;
    width:150px;
    height:30px;
    outline: none;
    cursor: pointer;
    float: right;
  }
  .operate .create{
    margin-right: 20px;
  }

  .Hcp-footer{
    font-family:HelveticaNeue;
    font-size:14px;
    color:rgba(120,120,120,0.90);
    letter-spacing:-0.34px;
    text-align:center;
    margin-top: 13px;
  }
  .Hcp-footer a{
    color:rgba(120,120,120,0.90);
    text-decoration: none;
  }
  .Hcp-footer a:hover{
    color:#0090D3;
  }

  input::-webkit-input-placeholder{
    color: #282828 !important;
  }
  input:-moz-placeholder{
    color: #282828 !important;
  }
  input::-moz-placeholder{
    color: #282828 !important;
  }
  input:-ms-input-placeholder{
    color: #282828 !important;
  }
</style>



// WEBPACK FOOTER //
// recent-updates.vue?4ed8fc1c